// extracted by mini-css-extract-plugin
export default {"actionItemWrapper":"holiday-list-view_actionItemWrapper__u5Ani"};